var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"organisation-page"},[_c('div',{staticClass:"organisation-page__wrapper"},[_c('router-view',{key:_vm.routerKey})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }